export default __webpack_public_path__ + "e8e17b77a449daa4228e3e3525217d3d.svg";